import React, { useState, useEffect } from 'react';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import Loading from '../../../components/Loading/Loading';
import FichaUsuarioContainer from './components/FichaUsuarioContainer';
import NovoUsuario from './NovoUsuario';
//Api
import usuario_api from '../../../api/usuario_api';
//Helpers
import { showMessage } from '../../../helpers/message';

export default function FichaUsuario({ btnVoltar, id, permissao }) {
    //Guarda os dados do usuario
    const [usuario, setUsuario] = useState();
    //Controla o loading na tela
    const [loading, setLoading] = useState(true);
    //Controla a tela de edição
    const [editar, setEditar] = useState(false);
    //Carrega os dados do usuario
    const loadUsuario = () => {
        setLoading(true);
        usuario_api.getItem(id).then(response => {
            response.data.setores = response.data.setores.map(value => {
                return { value: value.tbSetores_Id, label: value.descricaoSetor };
            })
            setUsuario(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    //Carrega os dados do usuario selecionado assim que o elemento é carregado
    useEffect(() => {
        loadUsuario();
    }, []);
    //Controle do loading na tela
    if (loading) {
        return <Loading />
    }
    //Controle da edição de usuario na tela
    if (editar) {
        return <NovoUsuario btnVoltar={btnVoltar} usuarioParam={usuario} />
    }
    return (
        <MainCard btnVoltar={btnVoltar} btnEditar={permissao === "Editar" ? () => setEditar(true) : null}>
            <FichaUsuarioContainer usuario={usuario} />
        </MainCard>
    )
}